module.exports = __webpack_public_path__ + "media/country_flags/cx-0ef00099.png";